module.exports = __webpack_public_path__ + "img/horn_5.cda65e53.png";